import { defineStore } from 'pinia';
import { ref } from 'vue';

const usePayoutsStore = defineStore('payout', () => {
  const payouts = ref([]);
  const setPayoutsData = (value) => {
    payouts.value = Object.values(value);
  };

  return {
    payouts,
    setPayoutsData,
  };
});

export default usePayoutsStore;
